import { render } from "./RepPatSummary2PatTestList.vue?vue&type=template&id=55062220"
import script from "./RepPatSummary2PatTestList.vue?vue&type=script&lang=js"
export * from "./RepPatSummary2PatTestList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__